<template lang="html">
  <div class="position-settings">
    <div class="section-header">
      <h2>Positions</h2>

      <button
        v-if="isCommissioner && !editing"
        class="small edit"
        @click="edit"
      >
        Edit
      </button>

      <div class="actions" v-if="editing">
        <a @click="cancel">Cancel</a>

        <button class="small edit" @click="save">
          Save
        </button>
      </div>
    </div>

    <section class="display" v-if="!editing">
      <div class="position">
        <div class="pos">Position</div>
        <div class="data"><b>Starters / Max</b></div>
      </div>

      <div
        class="position"
        v-for="{ position, starters, max } in positions"
        :key="position"
      >
        <div class="pos">{{ position }}</div>
        <div class="data">{{ starters }} / {{ max || 'na' }}</div>
      </div>
    </section>

    <section v-else>
      <form>
        <h5>Edit the number of starters and max players allowed for each position</h5>
        <p>Set starters to 0 if your draft won't include that position</p>

        <section class="position-edit" v-for="(position, i) in editPositions" :key="i">
          <h3>{{ position.position }}</h3>

          <div class="input-group">
            <div>
              <label>Starters</label>
              <input
                type="number"
                :min="0"
                :max="99"
                v-model.number="editPositions[i].starters"
              >
            </div>

            <div v-if="position.position !== 'FLEX'">
              <label>Max</label>
              <input
                type="number"
                :min="0"
                :max="99"
                v-model.number="editPositions[i].max"
              >
            </div>
          </div>
        </section>
      </form>

      <br />
      <button class="small edit" @click="save">
        Save
      </button>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import clonedeep from 'lodash.clonedeep';

export default {
  data() {
    return {
      editing: false,
      editPositions: [],
    };
  },

  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
      positions: ({ draft }) => draft.draft.positions,
    }),

    ...mapGetters({
      isCommissioner: 'draft/isCommissioner',
    }),
  },

  methods: {
    edit() {
      this.editPositions = clonedeep(this.positions);
      this.editing = true;
    },

    cancel() {
      this.editing = false;
    },

    save() {
      this.editing = false;

      this.$store.dispatch('draft/SAVE_POSITIONS', this.editPositions)
        .then(() => {
          this.$toast({ message: 'Saved your position settings' });
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import "./settings";

  .position-settings {
    @include settingSection;
  }

  .position {
    display: flex;
    margin: $gp / 2 0;

    .pos {
      font-weight: $font-weight-bold;
      width: px-to-rem(100px);
    }
  }

  form {
    max-width: 100%;
  }

  .position-edit {
    display: flex;
    flex-direction: column;
    margin-bottom: $gp;
    max-width: px-to-rem(360px);
  }
</style>
